import { ComputedRef, InjectionKey } from 'vue';
import { Universe, EntityType, User } from '@app/models';
import Roles from '@app/authorization/roles';

export const userKey: InjectionKey<ComputedRef<User | undefined>> = Symbol('user');
export const universeKey: InjectionKey<ComputedRef<Universe | undefined>> = Symbol('universe');
export const entityTypesKey: InjectionKey<ComputedRef<Array<EntityType> | undefined>> = Symbol('entity-types');
export const rolesKey: InjectionKey<ComputedRef<Roles | undefined>> = Symbol('roles');
export const entityTypeKey: InjectionKey<ComputedRef<EntityType | undefined>> = Symbol('entity-type');

export type KeyCallback = (event: Event) => void;

export const setTabKeyCallbackKey: InjectionKey<(callback: KeyCallback) => void> = Symbol('setTabKeyCallback');
export const setEnterKeyCallbackKey: InjectionKey<(callback: KeyCallback) => void> = Symbol('setEnterKeyCallback');
export const setUpKeyCallbackKey: InjectionKey<(callback: KeyCallback) => void> = Symbol('setUpKeyCallback');
export const setDownKeyCallbackKey: InjectionKey<(callback: KeyCallback) => void> = Symbol('setDownKeyCallback');
